import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ModalHeader from '../../common/Header'
import '../../../styles/Reports/GroupBoardingReport.scss'
import DropDown from '../../common/DropDown'
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import CustomDatePicker from '../../common/CustomDatePicker'
import MButton from '../../common/MButton'
import dayjs from 'dayjs'
import CustomRadio from '../../common/CustomRadio'
import { useDispatch, useSelector } from 'react-redux'
import { getCityList, getGroupBoardingFilter, updateShowAlert } from '../../../redux/Actions'
import SelectPickups from './SelectPickups'
import { isEmpty } from '../../../Utils'
import SelectServices from './SelectServices'
import SelectItemForSMS from './SelectItemsForSMS'
import SMSDetails from './SMSDetails'

const GroupBoardingReport = () => {
    const { cityList, userDetails } = useSelector((state) => state.common);
    const dispatch = useDispatch()
    const [filterValue, setFilterValue] = useState({
        city: [],
        date: dayjs(new Date()),
        isJourneyDate: 1,
        pickupGrp: [],
        pickup: [],
        serviceData: [],
        smsType:[],
        selectedItemsForSMS:[]
    })
    const [filterOpt, setFilterOpt] = useState({
        pickupGrp: [],
        pickup: [],
        serviceList: [],
        smsTypeList: [],
    })
    const [showSelectPickup, setShowSelectPickup] = useState(false)
    const [currentScreen, setCurrentScreen] = useState(1);
    useEffect(() => {
        if (!isEmpty(userDetails)) {
            const body = {
                strEntityType: 'B',
                intUserID: userDetails?.UserID,
                intCompanyID: userDetails?.CompanyID,
                intBranchID: userDetails?.BranchID,
                blnIsQuotaBranch: false,
                intAgentID: 0
            };
            dispatch(getCityList(body))
        }
    }, [userDetails?.CompanyID])
    const handleGenerate = () => {
        setShowSelectPickup(false)
        if (filterValue?.city?.length === 0) {
            dispatch(updateShowAlert({
                msg: 'Select From City!',
                open: true,
            }));
        } else {
            const bodyPickupFilter = {
                intUserID: userDetails?.UserID,
                intBranchID: userDetails?.BranchID,
                intCompanyID: userDetails?.CompanyID,
                JourneyDate: dayjs(filterValue?.date).format("YYYY-MM-DD"),
                intCityID: filterValue?.city?.[0]?.FromCityID || 0,
            };
            dispatch(getGroupBoardingFilter(bodyPickupFilter)).then((res) => {
                let data = res?.data?.APIMavenGroupboardingFiltersResult
                if (data.IsSuccess) {
                    const pickupList = JSON.parse(data.PickupList);
                    const pickupgroupsList = JSON.parse(data.Pickupgroups);
                    const ServiceList = JSON.parse(data.ServiceList);
                    const SMSTypeList = JSON.parse(data.SmsTemplates);
                    setFilterOpt((prev) => ({
                        ...prev,
                        pickupGrp: pickupgroupsList.Table || [],
                        pickup: pickupList.Table || [],
                        serviceList: ServiceList.Table || [],
                        smsTypeList: SMSTypeList.Table || [],
                    }))
                    setFilterValue((prev) => ({
                        ...prev,
                        pickup: [],
                        pickupGrp: []
                    }))
                } else {
                    dispatch(updateShowAlert({
                        msg: res?.data?.APIAgentRechargesInsertResult.ErrorMessage,
                        open: true,
                    }));
                }
            })
            setCurrentScreen(2);
            setShowSelectPickup(true)
        }
    }
    const radioList = [
        { label: "Journey Date", value: 1 },
        { label: "Chart Date", value: 2 },
    ];
    return (
        <Box className='GroupBoardingPage'>
            {currentScreen === 1 &&
                <>
                    <ModalHeader headerText={"Group Boarding Report"} showHamburger={true} />
                    <Box className='filter-section'>
                        <DropDown label='Select From City'
                            showTopLable={false}
                            headerLabel='Select City'
                            StartIcon={true}
                            Icon={DirectionsBusIcon}
                            option={[{ FromCityID: 0, FromCityName: "All Cities" }, ...cityList] || []}
                            primaryKey='FromCityID'
                            labelKey='FromCityName'
                            preSelectedValues={filterValue?.city || []}
                            onSelect={(val) => {
                                setFilterValue((prev) => ({
                                    ...prev,
                                    city: val
                                }))
                            }}
                        />
                        <Box className='datePicker'>
                            <CustomDatePicker
                                minDate={null}
                                selectedDate={filterValue?.date}
                                format='DD-MMM-YYYY'
                                onChange={(val) => {
                                    setFilterValue((prev) => ({
                                        ...prev,
                                        date: val
                                    }))
                                }}

                                style={{ width: '100%' }}

                            />
                        </Box>
                        <CustomRadio
                            name="journeyDate"
                            value={filterValue.isJourneyDate}
                            onChange={(e) => setFilterValue(prev => ({ ...prev, isJourneyDate: Number(e.target.value) }))}
                            radioList={radioList}
                            direction={'row'}
                        />
                        <MButton btnName="Proceed" onClick={handleGenerate} />
                    </Box>
                </>
            }
            {currentScreen === 2 &&
                <SelectPickups setCurrentScreen={setCurrentScreen} filterOpt={filterOpt} filterValue={filterValue} setFilterValue={setFilterValue} handleBack={() => {
                    setCurrentScreen(1)
                }} />
            }
            {currentScreen === 3 &&
                <SelectServices setCurrentScreen={setCurrentScreen} filterOpt={filterOpt} filterValue={filterValue} setFilterValue={setFilterValue} handleBack={() => {
                    setCurrentScreen(2)
                }} />
            }
            {currentScreen === 4 &&
                <SelectItemForSMS setCurrentScreen={setCurrentScreen} filterOpt={filterOpt} filterValue={filterValue} setFilterValue={setFilterValue} handleBack={() => {
                    setCurrentScreen(3)
                }} />
            }
            {currentScreen === 5 &&
                <SMSDetails setCurrentScreen={setCurrentScreen} filterOpt={filterOpt} filterValue={filterValue} setFilterValue={setFilterValue} handleBack={() => {
                    setCurrentScreen(4)
                }} />
            }

        </Box>
    )
}

export default GroupBoardingReport